import { Button } from "@mui/material";
import React from "react";
//TODO: any instance of this component should be replace with a regular button and removed
//This has 0 purpose
export default function MyButton({ message, type, ...rest }) {
  return (
    <Button type={type} {...rest}>
      {message}
    </Button>
  );
}
